var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 100,
    viewBox: "0 0 86 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93 2.758l-50.706.123a2.088 2.088 0 00-1.472.612c-.39.39-.608.919-.607 1.47l.232 92.705a2.07 2.07 0 00.614 1.467 2.083 2.083 0 001.475.604l50.708-.122a2.088 2.088 0 001.47-.612c.388-.39.607-.917.606-1.467l-.23-92.705a2.07 2.07 0 00-.614-1.469 2.085 2.085 0 00-1.475-.606z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.368 2.227l-49.572.12a1.906 1.906 0 00-1.905 1.908l.226 92.253a1.906 1.906 0 001.914 1.898l49.573-.12a1.906 1.906 0 001.904-1.908l-.226-92.253a1.906 1.906 0 00-1.914-1.898z",
    fill: "#202123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 28.999l-.053-22.341a2.018 2.018 0 00-.597-1.428 2.032 2.032 0 00-1.435-.588l-9.92.023a4.31 4.31 0 01-1.445 2.626 4.336 4.336 0 01-2.812 1.055l-18.44.044a4.337 4.337 0 01-2.817-1.04 4.31 4.31 0 01-1.458-2.62l-9.768.025a2.032 2.032 0 00-1.432.595c-.38.38-.592.894-.591 1.43l.055 22.37",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.289 29.15l.158 64.828c.001.537.216 1.05.597 1.428.381.378.898.59 1.435.589l46.659-.113a2.032 2.032 0 001.432-.596c.38-.38.592-.894.59-1.43l-.159-65.016",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.686 13.937h-9.913v9.88h9.913v-9.88z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.456 32.021H10v22.194h65.456V32.02z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.672 32.937H10.774v20.52h63.898v-20.52z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.118 40.532H36.26v1.976h24.858v-1.976zm0 3.956H36.26v1.976h24.858v-1.976z",
    fill: "#F9D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.118 62.426H36.26v1.976h24.858v-1.976zm0 3.951H36.26v1.976h24.858v-1.976zm-6.861-44.533H43.124v3.496h11.133v-3.496z",
    fill: "#4285F4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.947 47.387a4.698 4.698 0 004.695-4.702 4.698 4.698 0 00-4.695-4.702 4.698 4.698 0 00-4.695 4.702 4.698 4.698 0 004.695 4.702z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.964 45.975h-4.073a1.218 1.218 0 00-.991.525 6.123 6.123 0 006.019.033 1.21 1.21 0 00-.955-.558z",
    fill: "#F9D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.926 42.808s-.596 1.73-.923 1.568c0 0 3.141 2.704 5.914 0a8.245 8.245 0 00-1.194-1.568h-3.797z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.936 44.967a2.33 2.33 0 002.334-2.326 2.33 2.33 0 00-2.334-2.326 2.33 2.33 0 00-2.333 2.326 2.33 2.33 0 002.333 2.326z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.116 45.173h1.628v.63a.744.744 0 01-.748.745h-.14a.749.749 0 01-.747-.745v-.63h.007z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.288 45.135h1.285a.172.172 0 01.172.172v.459a.742.742 0 01-.462.69.75.75 0 01-.287.056h-.14a.749.749 0 01-.747-.745v-.459a.17.17 0 01.106-.159.173.173 0 01.066-.013l.007-.001z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.123 45.363a2.35 2.35 0 001.628 0v-.2h-1.628v.2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.936 45.477a2.33 2.33 0 002.334-2.326 2.33 2.33 0 00-2.334-2.326 2.33 2.33 0 00-2.333 2.326 2.33 2.33 0 002.333 2.326z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.702 42.264h4.448s-.379-1.79-2.061-1.674c-1.683.116-2.387 1.674-2.387 1.674z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.655 43.455c.12 0 .217-.182.217-.406 0-.225-.097-.406-.217-.406s-.217.181-.217.406c0 .224.097.406.217.406zm4.56 0c.12 0 .217-.182.217-.406 0-.225-.097-.406-.217-.406s-.217.181-.217.406c0 .224.097.406.217.406z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.702 42.33h4.448s-.379-1.79-2.061-1.674c-1.683.116-2.387 1.674-2.387 1.674z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.992 69.427a4.698 4.698 0 004.694-4.702 4.698 4.698 0 00-4.694-4.701 4.698 4.698 0 00-4.695 4.701 4.698 4.698 0 004.695 4.702zm0 18.089a4.698 4.698 0 004.694-4.701 4.698 4.698 0 00-4.694-4.702 4.698 4.698 0 00-4.695 4.702 4.698 4.698 0 004.695 4.701z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.118 79.902H36.26v1.975h24.858v-1.975zm0 3.951H36.26v1.976h24.858v-1.976zm0-69.916H36.26v1.975h24.858v-1.975zm0 3.955H36.26v1.976h24.858v-1.976z",
    fill: "#4285F4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.774 5.766l-11.337.17a.28.28 0 00-.276.283l.003.183a.28.28 0 00.284.275l11.337-.17a.28.28 0 00.276-.283l-.003-.183a.28.28 0 00-.284-.275zm2.816.699a.446.446 0 10-.012-.892.446.446 0 00.012.892z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30751,
    y1: 83062.5,
    x2: 70258.1,
    y2: 30054.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 28167.8,
    y1: 10091,
    x2: 28167.8,
    y2: 6560.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.46d49b49e008e61f25023678ddd7387c.svg";
export { ForwardRef as ReactComponent };